import React, { useState, useEffect } from "react";
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";
import * as FieldTypes from './FieldTypes/FieldTypes.js';

const AddItemCustomFields = ({ entityType, context }) => {

	const AppContext = context;
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {

		// Load custom fields

        let columnsUrl = "/umbraco/api/CustomFields/FieldsConfiguration/?entityType=" + entityType;

        let requestOptions = {
            method: "GET",
        };

        fetch(columnsUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                // Only custom fields
                data = data.filter(field => field.CustomFieldId != null);

                AppContext.setNewItemCustomFields(data);

            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });


        // Clear custom fields answers
        AppContext.setNewItemCustomFieldsAnswers([]);


	}, []);


	return <>

		{isLoading ? <div><LoadingSpinnerImage /></div> : <>

            <FieldTypes.FieldType_CustomUserFields globalContext={AppContext} isAdd={true} forceIsEditing={true} />

		</>}

	</>

}


export default AddItemCustomFields;